module.exports = __webpack_public_path__ + "4399abb016320b02b1146df009ceb1a2.png";